import { apiAuthClient } from 'shared/api/lib/apiAuthClient';

import type {
  PutCustomizationsDocumentRequestType,
  PutCustomizationsDocumentResponseType,
} from '../types';

export const putCustomizationsDocument = async ({
  pathParams: { organisationId },
  bodyParams,
}: PutCustomizationsDocumentRequestType) => {
  const url = `/api/v2/organisations/${organisationId}/customizations/document`;

  const { data } =
    await apiAuthClient.put<PutCustomizationsDocumentResponseType>(
      url,
      bodyParams,
    );

  return data;
};
